import React, { Component } from 'react';
import { Modal, Button, Header, Icon } from 'semantic-ui-react';
import IdleTimeout from './IdleTimeout';
import './IdleTimeout.css';

class IdleTimeoutWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      timeRemaining: 30,
      warningShown: false
    };
    
    this.idleTimeout = new IdleTimeout(30, '/');
    this.warningInterval = null;
  }

  componentDidMount() {
    // Start idle timeout monitoring
    this.idleTimeout.start();
    
    // Set up warning timer (show warning 5 minutes before timeout)
    this.warningInterval = setInterval(() => {
      const minutesRemaining = this.idleTimeout.getMinutesRemaining();
      
      if (minutesRemaining <= 5 && minutesRemaining > 0 && !this.state.warningShown) {
        this.setState({
          showWarning: true,
          timeRemaining: minutesRemaining,
          warningShown: true
        });
      }
    }, 60000); // Check every minute
  }

  componentWillUnmount() {
    // Clean up timers
    this.idleTimeout.stop();
    if (this.warningInterval) {
      clearInterval(this.warningInterval);
    }
  }

  handleExtendSession = () => {
    // Reset the idle timer
    this.idleTimeout.resetTimer();
    
    this.setState({
      showWarning: false,
      warningShown: false
    });
    
    // Show confirmation
    alert('Your session has been extended. You will be logged out after 60 minutes of inactivity.');
  }

  handleLogout = () => {
    // Clear session and redirect
    this.idleTimeout.handleTimeout();
  }

  render() {
    const { children } = this.props;
    const { showWarning, timeRemaining } = this.state;

    return (
      <>
        {children}
        
        <Modal
          open={showWarning}
          size="small"
          closeOnDimmerClick={false}
          closeOnEscape={false}
          className="idle-timeout-modal"
        >
          <Modal.Header>
            <Icon name="warning" color="yellow" />
            Session Timeout Warning
          </Modal.Header>
          <Modal.Content>
            <p>
              Your session will expire in <strong>{timeRemaining} minute{timeRemaining !== 1 ? 's' : ''}</strong> due to inactivity.
            </p>
            <p>
              Any unsaved work will be lost. Would you like to extend your session?
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={this.handleLogout}>
              <Icon name="sign-out" />
              Logout Now
            </Button>
            <Button primary onClick={this.handleExtendSession}>
              <Icon name="refresh" />
              Extend Session
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}

export default IdleTimeoutWrapper; 
